import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<DialogComponent>,
  ) { }

  ngOnInit() {
  }

  public accept() {
    this.dialogRef.close(this.data.accept);
  }

  public close() {
    this.dialogRef.close();
  }

}
